export const userDataSelector = (state) => state.user.data;
export const signInInProcessSelector = (state) => state.user.signInInProcess;
export const signInErrorsSelector = (state) => state.user.signInErrors;
export const getInProcessSelector = (state) => state.user.getInProcess;

export const isSuperAdminSelector = state =>state.user.isSuperAdmin;

export const resetPasswordErrorsSelector = (state) => state.user.resetPasswordErrors;
export const resetPasswordInProcessSelector = (state) =>
  state.user.resetPasswordInProcess;
